module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-image-1-3fbc4d33ee9143a2cad38b68d32c3d07.png";